// extracted by mini-css-extract-plugin
module.exports = {"form":"Checkout_form__3V8di","control":"Checkout_control__rjOvV","actions":"Checkout_actions__2Zg6U","submit":"Checkout_submit__1NetS","invalid":"Checkout_invalid__1OLbN"};